// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","loading":"Button_loading__5WK4e"};